import { render, staticRenderFns } from "./CompanyTrade.vue?vue&type=template&id=42c907ec&scoped=true&"
import script from "./CompanyTrade.vue?vue&type=script&lang=js&"
export * from "./CompanyTrade.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTrade.vue?vue&type=style&index=0&id=42c907ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c907ec",
  null
  
)

export default component.exports